import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/ListModeApi'

class Store {
  //查询条件
  @observable phone = ''
  @observable user_name = ''
  @observable date = []
  @observable entity_id = ''
  @observable time_str = ''
  @action
  setPhone(value) {
    this.phone = value
  }
  @action
  setUserName(value) {
    this.user_name = value
  }
  @action
  setDate(value) {
    this.date = value
  }
  @action
  setMealRoom(value) {
    this.entity_id = value
  }
  @action
  setMeals(value) {
    this.time_str = value
  }
  @action
  search() {
    this.getList(1)
  }
  @action
  reset() {
    this.phone = ''
    this.user_name = ''
    this.date = []
    this.entity_id = ''
    this.time_str = ''
  }
  @observable list = []
  @observable loading = false
  @observable
  pagination = {
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    current: 1,
    pageSize: 10,
    total: 0
  }
  @action
  async getList(page) {
    let params = this.getSearchParams(page)
    let {
      data: { list = [], total_count }
    } = await Api.getListMode(params)
    this.loading = true
    runInAction('list', () => {
      this.list = list
      this.loading = false
      this.pagination.total = total_count * 1
      this.pagination.current = page
    })
  }
  @action
  paging = ({ current }) => {
    this.pagination.current = current
    this.getList(current)
  }
  getSearchParams(page) {
    const { phone, user_name, date, entity_id, time_str } = this
    let date_max = ''
    let date_min = ''
    if (date.length == 0) {
      return {
        date_max,
        date_min,
        entity_id,
        time_str,
        user_name,
        phone,
        page,
        per_page: 10
      }
    } else {
      date_min = date[0].format('YYYY-MM-DD')
      date_max = date[1].format('YYYY-MM-DD')
      return {
        date_max,
        date_min,
        entity_id,
        time_str,
        user_name,
        phone,
        page,
        per_page: 10
      }
    }
  }
}
export default new Store()
